import { z } from "zod";

export const AppFeedbackRequestSchema = z.object({
  chatId: z.string().optional(),
  feedback: z.object({
    type: z.enum(["general", "bugReport", "featureRequest"]),
    input: z.string(),
  }),
  shareUserDetails: z.boolean(),
});

export type AppFeedbackType = z.infer<
  typeof AppFeedbackRequestSchema
>["feedback"]["type"];
export type AppFeedbackRequest = z.infer<typeof AppFeedbackRequestSchema>;

export const AppFeedbackResponseSchema = z.object({
  message: z.string(),
});

export type AppFeedbackResponse = z.infer<typeof AppFeedbackResponseSchema>;
